export default __webpack_public_path__ + "static/media/logo.18079a73.webp";